var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      staticClass: "photo-wrap"
    },
    [
      _c(
        "flexbox",
        {
          staticClass: "photo-content",
          style: { "font-size": _vm.fontSize + "px" },
          attrs: { justify: "center", align: "center" }
        },
        [_vm.text ? _c("div", [_vm._v(_vm._s(_vm.text))]) : _vm._e()]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }